import axios from 'axios';
import config from '../../../assets/config';
import { createAsyncThunk } from '@reduxjs/toolkit';
import authHeader from '../authHeader';

const backendURL = config.apiURL;
const base_url =window.location.origin+"/";

export const getUserType = createAsyncThunk(
    'type-role',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/GetUserType`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const getUserTypeService = createAsyncThunk(
    'type-sercies',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Security/GetUserTypeServices/${id}`,
                // payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const getUserRoleService = createAsyncThunk(
    'user-role-service',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Security/GetRoleToMenuServices/${id}`,
                // payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const addRoleService = createAsyncThunk(
    'add-user-fole-service',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/AddRoleServices`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const deleteUserRole = createAsyncThunk(
    'del-user-role',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Security/DeleteUserRole/${id}`,
                // payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const getUserTypeRl =createAsyncThunk(
    'ksfjls',
    async (id)=>{
        try{
            const {data} =await axios.get(
                `${base_url}api/api/Security/GetUserTypeRoles/${id}`,
                {headers:authHeader()}
            )
            return data;
        }
        catch(error){
            if(error.response && error.response.data){

            }else{

            }
        }
    }
)

export const removeRoleService = createAsyncThunk(
    'remove-role-servzsice',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/RemoveRoleService`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);
export const associatedRoleServices = createAsyncThunk(
    'associatedd-role-service',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/GetAssociateRoleServices`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);


// AddRoleServices,DeleteUserRole,RemoveRoleService,DeleteUserRole